module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_patch_3.44ee67ed.svg";